import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "@/lib/i18n";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

// localStorage guarda apenas preferência de idioma (não sensível); sessão fica em cookie httpOnly.
const ASKED_KEY = "mounjaro_language_picked";

export default function LanguageOnboarding() {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(() => {
    if (typeof window === "undefined") return false;
    return !localStorage.getItem(ASKED_KEY);
  });
  const [selected, setSelected] = useState(i18n.language?.split("-")[0] || "pt");

  const confirm = () => {
    i18n.changeLanguage(selected);
    localStorage.setItem("mounjaro_language", selected);
    localStorage.setItem(ASKED_KEY, "1");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      data-testid="language-onboarding"
    >
      <div className="bg-card border border-border rounded-2xl max-w-md w-full p-7 space-y-6 shadow-xl">
        <div className="text-center space-y-3">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-primary/20 border border-primary/40 flex items-center justify-center">
            <Sparkles className="w-7 h-7 text-primary" />
          </div>
          <h2 className="text-xl font-bold text-foreground">{t("languagePicker.title")}</h2>
          <p className="text-sm text-muted-foreground">{t("languagePicker.subtitle")}</p>
        </div>

        <div className="space-y-2">
          {SUPPORTED_LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              onClick={() => setSelected(lang.code)}
              data-testid={`lang-option-${lang.code}`}
              className={`w-full flex items-center gap-4 p-4 rounded-xl border transition-all ${
                selected === lang.code
                  ? "border-primary bg-primary/10"
                  : "border-border bg-secondary/30 hover:border-primary/50"
              }`}
            >
              <span className="text-3xl">{lang.flag}</span>
              <span className="font-semibold text-foreground flex-1 text-left">{lang.nativeName}</span>
              {selected === lang.code && (
                <span className="w-5 h-5 rounded-full bg-primary flex items-center justify-center text-primary-foreground text-xs">✓</span>
              )}
            </button>
          ))}
        </div>

        <Button onClick={confirm} className="w-full h-12 font-semibold" data-testid="lang-onboarding-confirm">
          {t("languagePicker.continue")}
        </Button>

        <p className="text-xs text-muted-foreground text-center">{t("languagePicker.changeAnytime")}</p>
      </div>
    </div>
  );
}
